import React, { useState } from 'react'
import SessionService from '../services/session'
import { localStorage } from './../state/utils/storage'
import TalkService from '../services/talk'

export default function useLocalEventLikes({
	eventId = null,
	conferenceCmsId = null,
}) {
	const [likesInfo, setLikesInfo] = useState()

	const isLiked = (idEvent, list = []) =>
		list.find(
			e =>
				e ===
				((eventId && conferenceCmsId) || (eventId === 0 && conferenceCmsId)
					? conferenceCmsId
					: idEvent)
		)

	const getLikesTalk = async () => {
		const localLikes = localStorage.getItem('LOCAL_EVENT_LIKES')
		const userData = SessionService.getUserData()
		let response
		try {
			if ((eventId && conferenceCmsId) || (eventId === 0 && conferenceCmsId)) {
				response = await TalkService.getLikes(
					conferenceCmsId,
					eventId === 0 ? null : eventId
				)
			} else {
				response = await TalkService.getLikes(eventId)
			}
			const { data } = response
			if ((!userData || userData === null) && isLiked(eventId, localLikes)) {
				setLikesInfo({ totalLikes: data.totalLikes, like: true })
			} else {
				setLikesInfo(data || { totalLikes: 0, like: false })
			}
		} catch (e) {
			setLikesInfo({
				totalLikes: 0,
				like: !!isLiked(eventId, localLikes),
			})
			console.error(e)
		}
	}

	const toogleLike = () => {
		try {
			const userData = SessionService.getUserData()

			if (!userData || userData === null) {
				if (!likesInfo?.like) {
					const localLikes = localStorage.getItem('LOCAL_EVENT_LIKES')
					const newLocalLikes = localLikes.concat(
						(eventId && conferenceCmsId) || (eventId === 0 && conferenceCmsId)
							? conferenceCmsId
							: eventId
					)
					localStorage.setItem('LOCAL_EVENT_LIKES', newLocalLikes)
				} else {
					const copyLocalLikes = localStorage.getItem('LOCAL_EVENT_LIKES') || []
					const newLocalLikes = copyLocalLikes.filter(
						e =>
							e !==
							((eventId && conferenceCmsId) ||
							(eventId === 0 && conferenceCmsId)
								? conferenceCmsId
								: eventId)
					)
					localStorage.setItem('LOCAL_EVENT_LIKES', newLocalLikes)
				}
			}

			setLikesInfo({
				totalLikes: likesInfo?.like
					? likesInfo?.totalLikes - 1 < 0
						? 0
						: likesInfo?.totalLikes - 1
					: likesInfo?.totalLikes + 1,
				like: !likesInfo?.like,
			})
			let payload = {}

			if ((eventId && conferenceCmsId) || (eventId === 0 && conferenceCmsId)) {
				payload = {
					conferenceCmsId,
					event: eventId === 0 ? null : eventId,
					like: !likesInfo?.like,
				}
			} else {
				payload = {
					conferenceCmsId: eventId,
					like: !likesInfo?.like,
				}
			}
			TalkService.setLike(payload)
		} catch (e) {
			console.error(e)
		}
	}

	React.useEffect(() => {
		localStorage.setItem(
			'LOCAL_EVENT_LIKES',
			localStorage.getItem('LOCAL_EVENT_LIKES') || '[]'
		)
		getLikesTalk()
	}, [])

	return { likesInfo, setLikesInfo, getLikesTalk, toogleLike }
}
